export interface InfoSettings {
  infoData: any;
}
export default {} as InfoSettings;

export const spaceName = 'caInfo';
